<template>
  <div :class="classModifiers">
    <div class="account-upload-document__icon">
      <img src="@/assets/icons/identity.svg" />
    </div>
    <template v-if="isPending">
      <template v-if="isCard">
        <p class="account-upload-document__note">
          Your identification documents are under review. We will notify you by email regarding your
          status within 72 hours of submission. You will be able to deposit funds once your identity
          has been confirmed.
        </p>
        <p class="account-upload-document__note" v-if="false">
          Don’t want to wait? Try Online Banking instead. No document upload required. Start trading
          now!
        </p>
      </template>
      <p class="account-upload-document__note" v-else-if="isPopup">
        Your identification documents are under review. We will notify you by email regarding your
        status within 72 hours of submission. You will be able to deposit funds once your identify
        has been confirmed. Thank you for your patience.
      </p>
      <p class="account-upload-document__note" v-else>
        Your identification documents are under review. We will notify you by email regarding your
        status within 72 hours of submission. You will be able to deposit funds once your identify
        has been confirmed. Thank you for your patience.
      </p>
    </template>
    <template v-else>
      <template v-if="isCard">
        <p class="account-upload-document__note">
          To use a credit card, PredictIt requires all traders to upload a proof of identity
          document. We will then review the document as quickly as possible so that you can start
          trading.
        </p>
        <p class="account-upload-document__note" v-if="false">
          Don’t want to wait? Try Online Banking instead. No document upload required. Start trading
          now!
        </p>
      </template>
      <p class="account-upload-document__note" v-else-if="isPopup">
        We are required to collect further documentation in order to process your transaction.
        Please click to upload an identity document.
      </p>
      <p class="account-upload-document__note" v-else>
        We are required to collect documentation in order to process further deposits or
        withdrawals. Please click to upload an identity document.
      </p>
      <button
        class="button button--large button--primary button--full-width"
        @click.prevent="onButtonClick"
      >
        Upload Document
      </button>
    </template>
  </div>
</template>

<script src="./account-upload-document.js"></script>
<style src="./account-upload-document.scss" lang="scss"></style>
